import React from "react";
import { Input, Form } from "antd";
import { Styles } from "../Config/ThemeConfig";

export function Textarea({
  label,
  name,
  required,
  validation,
  onchange,
  className,
  disabled,
  value = "",
}) {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={[
        {
          required,
          message: validation,
        },
      ]}
      className={`w_100_p m_0 ${className}`}
    >
      <Input.TextArea
        value={value}
        onChange={onchange}
        size={Styles.input_size}
        disabled={disabled || false}
      />
    </Form.Item>
  );
}
